module.exports = __webpack_public_path__ + "img/prepare-header-top.f5c9569b.png";